import React, { useState } from "react"
import ReactPlayer from "react-player/youtube"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { XIcon } from "lucide-react"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"

export const FlashcardsTutorial: React.FC = () => {
  const [openModal, setOpenModal] = useState(false)
  const [openBanner, setOpenBanner] = useState(true)

  const handleOnClickShowTutorial = () => {
    setOpenModal(!openModal)
  }

  return (
    <article className="w-full">
      <article
        className={cn(
          "flex w-full items-center justify-between rounded-2xl bg-[#9C1B97] p-2",
          !openBanner && "hidden",
        )}
      >
        <section className="flex flex-col items-center gap-4 sm:mr-4 sm:flex-row">
          <span className="text-md text-center text-white sm:ml-4">
            <span className="font-medium">¿Qué son las flashcards y cómo utilizarlas? </span>
            Mirá este video
          </span>
          <Button className="rounded-2xl" variant="outline" onClick={handleOnClickShowTutorial}>
            Ver tutorial
          </Button>
        </section>
        <XIcon
          onClick={() => setOpenBanner(!openBanner)}
          className="cursor-pointer text-white"
          size={32}
        />
      </article>
      <Dialog open={openModal} onOpenChange={setOpenModal}>
        <DialogContent className="w-[90%] sm:w-1/2">
          <DialogHeader>
            <DialogTitle>Video tutorial</DialogTitle>
          </DialogHeader>
          <section className="w-full gap-4 py-4">
            <ReactPlayer
              width={"100%"}
              height={"400px"}
              url="https://youtu.be/FTy-xKyPlMY"
              controls
            />
          </section>
        </DialogContent>
      </Dialog>
    </article>
  )
}
